import React from 'react';
import OpenAssignmentSearchParams from './OpenAssignmentSearchParams';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OpenAssignmentItem from '../../../../Domain/OpenAssignmentItem';
import AssignmentService from '../../../../Services/AssignmentService';

export default class OpenAssignmentAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OpenAssignmentSearchParams()
    };

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OpenAssignmentItem}
          serviceFunction={AssignmentService.GetOpenAssignmentListBySearching}
          convertDBItemsFunction={AssignmentService.ConvertOpenAssignmentDBItems}
          searchParamsType={OpenAssignmentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='ClientName'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client sassie id & name...'
          errorCode='OAAxx'
        />
      </div>
    );
  }
}
